function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @license
 * Copyright (c) 2021 Handsoncode. All rights reserved.
 */
export var InterpreterState = function InterpreterState(formulaAddress, arraysFlag, formulaVertex) {
  _classCallCheck(this, InterpreterState);

  this.formulaAddress = formulaAddress;
  this.arraysFlag = arraysFlag;
  this.formulaVertex = formulaVertex;
};